/**
 * Reaching §F5.10's draw toggle from §F6's AOI card.
 *
 * §H2's no-AOI state is "explainer + `Start drawing` (closes dock, activates draw)", and
 * the tool that draws lives in the map's own column: `#btnDraw` owns the exclusive
 * measure/draw mode, the Leaflet handlers and the "re-click clears + releases clip" rule.
 *
 * So the dock presses that button, exactly as the mockup does (`$('#btnDraw').click()`),
 * rather than the mode being lifted into the store to serve one cross-panel call. Two
 * writers on a mode that must have exactly one is how a tool ends up both active and off.
 * The id is a constant here so the coupling has a name and one place to change.
 */
export const DRAW_BUTTON_ID = 'btnDraw';

/** `false` when the button is not on screen — i.e. the map is not mounted. */
export function startDrawing(): boolean {
  const btn = document.getElementById(DRAW_BUTTON_ID);
  if (!btn) return false;
  btn.click();
  return true;
}
